import { Col, Container, Row } from "react-bootstrap";

export default function Contact() {
    function resizeIframe(obj) {
        obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
      }
    return(<Container>
        <Row>
            <Col sm="12" md="6">
                
            <iframe width="100%" src="https://forms.office.com/Pages/ResponsePage.aspx?id=S1xNYsVFIkGM0ETw-E6UXQDmvvaESF5GnIUtI5f06ypUN0IzOVM4VVRFOTRRQjVFSkhZVEc1MFdBQi4u&embed=true" frameBorder="0" marginWidth="0" marginHeight="0" 
            style={{border: "none", maxWidth:"100%", maxHeight:"100vh", height: "1000px", overflow: "hidden"}}
             allowFullScreen> </iframe>
    </Col>
            <Col sm="12" md="6">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.7790939814195!2d77.19049767453808!3d28.546358887990415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1df5dfa72731%3A0x7184789708264525!2sCentre%20For%20Rural%20Development%20And%20Technology%20(CRDT)%2C%20IIT%20Delhi!5e0!3m2!1sen!2sin!4v1733392133979!5m2!1sen!2sin" width="100%" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </Col>
        </Row>
    </Container>
    )
}